var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRootFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#F37321"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 2.5V5.8H7.45455V7.45H4.18182C3.57636 7.45 3.09091 7.9395 3.09091 8.55V11.2H2V14.5H5.27273V11.2H4.18182V8.55H7.45455V11.2H6.36364V14.5H9.63636V11.2H8.54545V8.55H11.8182V11.2H10.7273V14.5H14V11.2H12.9091V8.55C12.9091 7.9395 12.4236 7.45 11.8182 7.45H8.54545V5.8H9.63636V2.5H6.36364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRootFill);
export default __webpack_public_path__ + "static/media/icon-root-fill.a99f8e5d668e0ff3ab63d1b0b0e53c08.svg";
export { ForwardRef as ReactComponent };